<template>
  <Mask />
  <div class="page">
    <img class="loading" :src="loading" alt="">
    <div class="tips">{{ t('loading.message1') }}
      <div class="progress" v-if="isFailure" style="color:red;cursor: pointer;" @click="checkAgain()">{{ t('loading.message2')
        }}</div>
    </div>
<!--    <div class="line">-->
<!--      <el-progress :show-text="false" :stroke-width="22" :percentage="progress" />-->
<!--    </div>-->
    <div class="progress-container">
      <div ref="progressBar" id="progressBar" class="progress-bar"></div>
    </div>
  </div>
</template>

<script name="Loading" setup>
import { essayResultById, perspectiveExtendResultById, continueWritingResultById,essayCheckAgain,
perspectiveExtendCheckAgain,continueWritingCheckAgain } from "@/api/api";
import i18n from '../locale/i18n';
import Mask from './Mask.vue'
import loading from '../assets/list/loading.png'
import { useRouter, useRoute } from 'vue-router';

const t = (key) => i18n.global.t(key);
const router = useRouter();
const progress = ref(0)
const props = defineProps({
  loadingConfig: {
    type: Object
  }
});
const progressBar = ref(null)
const isFailure = ref(false);
const checkAgain = async () =>{
  isFailure.value = false;
  const info = props.loadingConfig.info
  if(info.type == '0') {
    const res = await essayCheckAgain(info.id)
  } else if(info.type == '2') {
    const res = await perspectiveExtendCheckAgain(info.id)
  } else if(info.type == '3') {
    const res = await continueWritingCheckAgain(info.id)
  }
  updateProgressBar();
}

const updateProgressBar = () => {
  if (progressBar.value) {
    progressBar.value.style.animationPlayState = 'running'
  }
  const statusInterval = setInterval(async () => {
    let status = null
    const info = props.loadingConfig.info
    // '0': '作文评分', '2': '思路扩展', '3': '观点续写'
    if(info.type == '0') {
      const res = await essayResultById(info.id)
      status = res.data.essay.status
    } else if(info.type == '2') {
      const res = await perspectiveExtendResultById(info.id)
      status = res.data.perspectiveExtend.status
    } else if(info.type == '3') {
      const res = await continueWritingResultById(info.id)
      status = res.data.continueWriting.status
    }
    if(status == '2') {
      progress.value = 100;
      clearInterval(statusInterval); // 清除定时器，完成进度
      if(info.type == '0') {
        router.push({path:'sample', query:{ id: info.id }})
      } else if(info.type == '2') {
        router.push({path:'perspectiveExtend', query:{ id: info.id }})
      } else if(info.type == '3') {
        router.push({path:'continueWriting', query:{ id: info.id }})
      }
    }
    if(status == '3') {
      // '0': '作文评分', '2': '思路扩展', '3': '观点续写'
      isFailure.value = true;
      clearInterval(statusInterval); // 清除定时器，完成进度
      if (progressBar.value) {
        progressBar.value.style.animationPlayState = 'paused'
      }

    }
  }, 2000);
}

onMounted(() => {
  updateProgressBar()
})
</script>

<style lang="less" scoped>
.page {
  width: 58.85vw;
  height: 40.89vw;
  border-radius: 1.04vw;
  background: rgba(255, 255, 255, 1);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .loading {
    width: 25.42vw;
    height: auto;
  }
  .tips {
    font-size: 1.15vw;
    font-weight: 900;
    color: rgba(56, 112, 255, 1);
    margin-bottom: 7.4vw;
  }
  .progress {
    font-size: 1.15vw;
    font-weight: 900;
    color: rgba(56, 112, 255, 1);
    margin-bottom: 0.4vw;
  }
  .progress-container {
    position: relative;
    width: 100%;
    height: 4px;
    background-color: #f3f3f3;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .progress-bar {
    position: absolute;
    width: 30%;
    height: 100%;
    background-color: #409eff;
    animation: loop 2s infinite linear;
    /* 初始为暂停状态 */
    animation-play-state: paused;
  }

  @keyframes loop {
    0% {
      left: -30%;
    }
    50% {
      left: 50%;
    }
    100% {
      left: 100%;
    }
  }
}
</style>
